<template>
  <!--会议详情-->
  <div id="myMeetingDetail"></div>
</template>

<script>
export default {
  name: 'myMeetingDetail'
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/login/myMeetingDetail.vue